import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WatermarkService } from '../../services/watermark.service';

import { IWatermarkConfig } from 'app/shared/interfaces/media.interfaces';

@Component({
  selector: 'stxt-watermark',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './watermark.component.html',
  styleUrl: './watermark.component.scss'
})
export class WatermarkComponent implements OnInit, OnChanges {
  @Input() config: IWatermarkConfig;
  @Input() isVisible: boolean = true;

  public watermarkText: string = '';
  public showWatermark: boolean = false;

  private isInitialized: boolean = false;
  private lastConfig: IWatermarkConfig | null = null;
  private lastVisibility: boolean = true;

  constructor(public readonly watermarkService: WatermarkService) {}

  ngOnInit(): void {
    this.initializeWatermark();
    this.isInitialized = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    const configChanged =
      changes['config'] && changes['config'].currentValue !== changes['config'].previousValue;
    const visibilityChanged =
      changes['isVisible'] &&
      changes['isVisible'].currentValue !== changes['isVisible'].previousValue;

    if (this.isInitialized && (configChanged || visibilityChanged)) {
      this.initializeWatermark();
    }
  }

  private initializeWatermark(): void {
    if (!this.config) {
      this.showWatermark = false;
      this.watermarkText = '';
      return;
    }

    if (this.lastConfig === this.config && this.lastVisibility === this.isVisible) {
      return;
    }

    this.showWatermark = this.watermarkService.shouldShowWatermark(this.config) && this.isVisible;

    if (this.showWatermark) {
      this.watermarkText = this.watermarkService.generateWatermarkText(this.config.creatorName);
    } else {
      this.watermarkText = '';
    }

    this.lastConfig = this.config;
    this.lastVisibility = this.isVisible;
  }

  onTextClick(): void {
    if (this.config?.creatorId) {
      this.watermarkService.navigateToCreator();
    }
  }
}
